import { createFileRoute } from "@tanstack/react-router";

import { AdminAppSettingsScreen } from "@/features/admin/screens/AdminAppSettings";

export const Route = createFileRoute(
  "/_authenticated/(admin)/admin/app-settings",
)({
  component: AdminAppSettingsScreen,
});
